<template>
	<b-modal
		ref="modal"
		centered
		scrollable
		title="Full Text"
		:modal-class="theme"
		body-class="modal__confirm"
		size="xl"
		ok-only
		ok-title="Close"
	>
		{{ text }}
	</b-modal>
</template>

<script>
import ThemeService from '../../services/theme';

export default {
	name: "FullTextDialog",
	data: function () {
		return {
			text: '',
			theme: "light",
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function (text) {
			this.text=text;
			this.$refs.modal.show();
		},
		hide: function () {
			this.$refs.modal.hide();
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style>
</style>